import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";
import { SkillDetailContent } from "@/pages/skills/SkillDetailContent";
import { ArrowLeft, ScrollText } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export const CreateSkillPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <title>Create Skill</title>
      <div className="py-2 pt-[50px]">
        <div className="space-y-8">
          {/* Header */}
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <ScrollText className="h-8 w-8 text-muted-foreground" />
                <h1 className="text-3xl font-bold">New Skill</h1>
              </div>
              <p className="text-muted-foreground">
                Create a new skill to enhance your AI assistant's capabilities
                and knowledge.
              </p>
            </div>
            <Button
              variant="outline"
              onClick={() => navigate(ROUTES.SKILLS.ROOT)}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Skills
            </Button>
          </div>

          <SkillDetailContent mode="create" context="page" />
        </div>
      </div>
    </>
  );
};
